
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next";


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
      },
      ru: {
        translation: {
          // form labels
          "Invitation": "Данные въезжающего",
          "Last name": "Фамилия",
          "Middle name": "Отчество",
          "First name": "Имя",
          "Date of birthday": "Дата рождения",
          "Day": "День",
          "Month": "Месяц",
          "Year": "Год",
          "Passport number": "Номер паспорта",
          "Date of issue": "Дата выдачи",
          "Valid to": "Годен до",
          "Purpose": "Цель поездки",
          "Tourism": "Туризм",
          "tourism": "туризм",
          "Sex": "Пол",
          "Male": "Mужской",
          "Female": "Женский",
          "Citizenship": "Гражданство",
          "Choose country": "Выберите страну",
          "Choose city": "Выберите город",
          "Choose hotel": "Выберите отель",
          "Date of Arrival to": "Дата прибытия",
          "Exit from Russia": "Выезд до",
          "Cities to visit": "Города для посещения",
          "Field is required": "Обязательное поле",
          "Submit": "Отправить",
          // cities
          "Moscow": "Москва",
          "Saint-Petersburg": "Санкт-Петербург",
          "The form has been submitted successfully!": "Форма была успешно отправлена!",
          "If you want to submit another one please click": "Если Вы хотели бы отправить еще одну, пожалуйста нажмите",
          "go back": "вернуться",
          "Add another": "Добавить другой"
        }
      }
    },
    lng: "ru",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });

export default i18n